import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import {
    FaTractor,
    FaMapMarkerAlt,
    FaEllipsisH,
    FaHeart,
    FaRegHeart,
    FaShare,
    FaQrcode
} from 'react-icons/fa';

const Breadcrumb = ({ 
    items, 
    backLink, 
    nextLink, 
    className = '',
    lot = null,
    auction = null,
    auctionSlug = null,
    isFavorite = false,
    onToggleFavorite = null,
    onShareClick = null,
    onQRCodeClick = null
}) => {
    return (
        <div 
            className={`breadcrumb-wrapper ${className}`}
            style={{
                width: '100%',
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #e9ecef'
            }}
        >
            <div className="container-fluid px-2 px-lg-3" style={{ paddingTop: '12px', paddingBottom: '12px' }}>
            <style>{`
                .breadcrumb-wrapper .breadcrumb-item + .breadcrumb-item::before {
                    content: ">";
                    color: #000000;
                    padding: 0 0.75rem;
                    font-weight: 500;
                }
                .breadcrumb-wrapper .breadcrumb-item a {
                    color: #000000 !important;
                    font-weight: 500;
                    transition: all 0.2s ease;
                }
                .breadcrumb-wrapper .breadcrumb-item a:hover {
                    color: #333333 !important;
                    text-decoration: underline !important;
                }
                .breadcrumb-wrapper .breadcrumb-item.active {
                    color: #000000 !important;
                    font-weight: 600;
                }
            `}</style>
            
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb mb-0" style={{ 
                    fontSize: '15px',
                    backgroundColor: 'transparent',
                    padding: 0,
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                }}>
                    {items.map((item, index) => {
                        const isLast = index === items.length - 1;
                        return (
                            <li 
                                key={index} 
                                className={`breadcrumb-item ${isLast || item.active ? 'active' : ''}`}
                                aria-current={isLast || item.active ? 'page' : undefined}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}
                            >
                                {item.to && !isLast && !item.active ? (
                                    <Link to={item.to} className="text-decoration-none">
                                        {item.label}
                                    </Link>
                                ) : (
                                    <span>{item.label}</span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
            
            {/* Optional Navigation Links */}
            {(backLink || nextLink) && (
                <div 
                    className="d-flex justify-content-between align-items-center pt-2" 
                    style={{ 
                        borderTop: '1px solid #e9ecef',
                        paddingTop: '8px',
                        marginTop: '8px'
                    }}
                >
                    {backLink ? (
                        backLink.onClick ? (
                            <a
                                href={backLink.to || '#'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    backLink.onClick(e);
                                }}
                                className="text-decoration-none d-flex align-items-center"
                                style={{ 
                                    color: '#0066cc', 
                                    fontSize: '14px', 
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease',
                                    cursor: 'pointer',
                                    lineHeight: '1.5',
                                    gap: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#0052a3';
                                    e.currentTarget.style.textDecoration = 'underline';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#0066cc';
                                    e.currentTarget.style.textDecoration = 'none';
                                }}
                            >
                                {backLink.label || '← Back'}
                            </a>
                        ) : (
                            <Link 
                                to={backLink.to || '#'} 
                                className="text-decoration-none d-flex align-items-center"
                                style={{ 
                                    color: '#0066cc', 
                                    fontSize: '14px', 
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease',
                                    lineHeight: '1.5',
                                    gap: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#0052a3';
                                    e.currentTarget.style.textDecoration = 'underline';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#0066cc';
                                    e.currentTarget.style.textDecoration = 'none';
                                }}
                            >
                                {backLink.label || '← Back'}
                            </Link>
                        )
                    ) : (
                        <div></div>
                    )}
                    
                    {nextLink ? (
                        nextLink.onClick ? (
                            <a
                                href={nextLink.to || '#'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    nextLink.onClick(e);
                                }}
                                className="text-decoration-none d-flex align-items-center"
                                style={{ 
                                    color: '#0066cc', 
                                    fontSize: '14px', 
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease',
                                    cursor: 'pointer',
                                    lineHeight: '1.5',
                                    gap: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#0052a3';
                                    e.currentTarget.style.textDecoration = 'underline';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#0066cc';
                                    e.currentTarget.style.textDecoration = 'none';
                                }}
                            >
                                {nextLink.label || 'Next →'}
                            </a>
                        ) : (
                            <Link 
                                to={nextLink.to || '#'} 
                                className="text-decoration-none d-flex align-items-center"
                                style={{ 
                                    color: '#0066cc', 
                                    fontSize: '14px', 
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease',
                                    lineHeight: '1.5',
                                    gap: '4px'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.color = '#0052a3';
                                    e.currentTarget.style.textDecoration = 'underline';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.color = '#0066cc';
                                    e.currentTarget.style.textDecoration = 'none';
                                }}
                            >
                                {nextLink.label || 'Next →'}
                            </Link>
                        )
                    ) : (
                        <div></div>
                    )}
                </div>
            )}
            </div>

            {/* Header Section with Title, Icon, and Actions - For Auctions */}
            {auction && !lot && (
                <div 
                    style={{
                        width: '100%',
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        backgroundColor: '#ffffff',
                        borderTop: '1px solid #e9ecef',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                    }}
                >
                    <div className="container-fluid px-2 px-lg-3">
                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                            <div className="d-flex align-items-start" style={{ flex: 1, minWidth: '300px' }}>
                                {/* Category Icon */}
                                {auction?.category?.icon && (
                                    <div 
                                        className="me-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px',
                                            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                            boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 99, 235, 0.35)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.25)';
                                        }}
                                    >
                                        <span 
                                            dangerouslySetInnerHTML={{ __html: auction.category.icon }}
                                            style={{ 
                                                color: '#ffffff', 
                                                fontSize: '28px',
                                                lineHeight: '1',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                backdropFilter: 'blur(10px)'
                                            }} 
                                        />
                                    </div>
                                )}
                                
                                {/* Title and Auction Info */}
                                <div style={{ flex: 1, paddingTop: '4px', position: 'relative' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                        <h1 className="mb-2" style={{ 
                                            fontSize: '28px', 
                                            fontWeight: '700', 
                                            color: '#1a1a1a',
                                            lineHeight: '1.2',
                                            letterSpacing: '-0.5px',
                                            marginBottom: '8px',
                                            margin: 0
                                        }}>
                                            {auction?.title}
                                        </h1>
                                        {/* Featured Ribbon Badge */}
                                        {auction?.is_featured && (
                                            <div style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #ffd700 100%)',
                                                backgroundSize: '200% 100%',
                                                animation: 'shimmer 3s ease-in-out infinite',
                                                color: '#1f2937',
                                                padding: '6px 16px',
                                                borderRadius: '20px',
                                                fontSize: '12px',
                                                fontWeight: 700,
                                                boxShadow: '0 4px 12px rgba(255, 215, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.1)',
                                                border: '2px solid rgba(255, 255, 255, 0.5)',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px',
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}>
                                                <span style={{
                                                    display: 'inline-block',
                                                    fontSize: '14px',
                                                    animation: 'pulse 2s ease-in-out infinite'
                                                }}>⭐</span>
                                                <span>Featured</span>
                                                <style>{`
                                                    @keyframes shimmer {
                                                        0%, 100% { background-position: 0% 50%; }
                                                        50% { background-position: 100% 50%; }
                                                    }
                                                    @keyframes pulse {
                                                        0%, 100% { transform: scale(1); opacity: 1; }
                                                        50% { transform: scale(1.2); opacity: 0.8; }
                                                    }
                                                `}</style>
                                            </div>
                                        )}
                                    </div>
                                    {auction?.location && (
                                        <div 
                                            className="d-flex align-items-center gap-2 flex-wrap mt-2" 
                                            style={{ 
                                                fontSize: '13px',
                                                color: '#6b7280',
                                                fontWeight: '500'
                                            }}
                                        >
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <FaMapMarkerAlt style={{ fontSize: '12px', color: '#94a3b8' }} />
                                                {auction.location}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Action Buttons */}
                            <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0, marginTop: '4px' }}>
                                {/* Action Icons */}
                                <div className="d-flex gap-2">
                                    {/* Favorite Icon */}
                                    {onToggleFavorite && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onToggleFavorite}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: isFavorite ? '#fef2f2' : '#ffffff',
                                                border: `1px solid ${isFavorite ? '#fecaca' : '#e2e8f0'}`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: isFavorite ? '#ef4444' : '#475569',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = isFavorite ? '#fee2e2' : '#f8fafc';
                                                e.currentTarget.style.borderColor = isFavorite ? '#fca5a5' : '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = isFavorite ? '#fef2f2' : '#ffffff';
                                                e.currentTarget.style.borderColor = isFavorite ? '#fecaca' : '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                            }}
                                            title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                                        >
                                            {isFavorite ? (
                                                <FaHeart style={{ fontSize: '18px' }} />
                                            ) : (
                                                <FaRegHeart style={{ fontSize: '18px' }} />
                                            )}
                                        </button>
                                    )}
                                    
                                    {/* QR Code Icon */}
                                    {onQRCodeClick && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onQRCodeClick}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#1a1a1a',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                                e.currentTarget.style.borderColor = '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.color = '#000000';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.color = '#1a1a1a';
                                            }}
                                            title="Show QR Code"
                                        >
                                            <FaQrcode style={{ fontSize: '18px' }} />
                                        </button>
                                    )}
                                    
                                    {/* Share Icon */}
                                    {onShareClick && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onShareClick}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#475569',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                                e.currentTarget.style.borderColor = '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.color = '#334155';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.color = '#475569';
                                            }}
                                            title="Share auction"
                                        >
                                            <FaShare style={{ fontSize: '18px' }} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Header Section with Title, Icon, and Actions - For Lots */}
            {lot && (
                <div 
                    style={{
                        width: '100%',
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        backgroundColor: '#ffffff',
                        borderTop: '1px solid #e9ecef',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                    }}
                >
                    <div className="container-fluid px-2 px-lg-3">
                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                            <div className="d-flex align-items-start" style={{ flex: 1, minWidth: '300px' }}>
                                {/* Category Icon */}
                                <div 
                                    className="me-3"
                                    style={{
                                        width: '60px',
                                        height: '60px',
                                        borderRadius: '12px',
                                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(37, 99, 235, 0.35)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.25)';
                                    }}
                                >
                                    {lot?.auction?.category?.icon ? (
                                        <span 
                                            dangerouslySetInnerHTML={{ __html: lot.auction.category.icon }}
                                            style={{ 
                                                color: '#ffffff', 
                                                fontSize: '28px',
                                                lineHeight: '1',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                backdropFilter: 'blur(10px)'
                                            }} 
                                        />
                                    ) : (
                                        <div style={{
                                            width: '44px',
                                            height: '44px',
                                            borderRadius: '10px',
                                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                            backdropFilter: 'blur(10px)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <FaTractor style={{ color: '#ffffff', fontSize: '28px' }} />
                                        </div>
                                    )}
                                </div>
                                
                            {/* Title and Lot Info */}
                            <div style={{ flex: 1, paddingTop: '4px', position: 'relative' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                <h1 className="mb-2" style={{ 
                                    fontSize: '28px', 
                                    fontWeight: '700', 
                                    color: '#1a1a1a',
                                    lineHeight: '1.2',
                                    letterSpacing: '-0.5px',
                                        marginBottom: '8px',
                                        margin: 0
                                }}>
                                    {lot?.title}
                                </h1>
                                    {/* Featured Ribbon Badge */}
                                    {lot?.is_featured && (
                                        <div style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #ffd700 100%)',
                                            backgroundSize: '200% 100%',
                                            animation: 'shimmer 3s ease-in-out infinite',
                                            color: '#1f2937',
                                            padding: '6px 16px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: 700,
                                            boxShadow: '0 4px 12px rgba(255, 215, 0, 0.4), 0 2px 4px rgba(0, 0, 0, 0.1)',
                                            border: '2px solid rgba(255, 255, 255, 0.5)',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}>
                                            <span style={{
                                                display: 'inline-block',
                                                fontSize: '14px',
                                                animation: 'pulse 2s ease-in-out infinite'
                                            }}>⭐</span>
                                            <span>Featured</span>
                                            <style>{`
                                                @keyframes shimmer {
                                                    0%, 100% { background-position: 0% 50%; }
                                                    50% { background-position: 100% 50%; }
                                                }
                                                @keyframes pulse {
                                                    0%, 100% { transform: scale(1); opacity: 1; }
                                                    50% { transform: scale(1.2); opacity: 0.8; }
                                                }
                                            `}</style>
                                        </div>
                                    )}
                                </div>
                                <div 
                                    className="d-flex align-items-center gap-2 flex-wrap" 
                                    style={{ 
                                        fontSize: '13px',
                                        color: '#6b7280',
                                        fontWeight: '500'
                                    }}
                                >
                                        <span style={{ 
                                            backgroundColor: '#f1f5f9',
                                            padding: '6px 14px',
                                            borderRadius: '8px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: '#475569',
                                            border: '1px solid #e2e8f0'
                                        }}>
                                            Lot {lot?.lot_number || '1'}
                                        </span>
                                        <span style={{ color: '#cbd5e1' }}>•</span>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FaMapMarkerAlt style={{ fontSize: '12px', color: '#94a3b8' }} />
                                            {lot?.location || lot?.auction?.location || 'Location not specified'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Action Buttons */}
                            <div className="d-flex align-items-center gap-2" style={{ flexShrink: 0, marginTop: '4px' }}>
                                {/* Enter Auction Button */}
                                {lot?.auction && (() => {
                                    const now = moment();
                                    const startTime = lot.auction?.start_time ? moment(lot.auction.start_time) : null;
                                    const isLiveOrActive = lot.auction?.status === 'live' || 
                                                          (lot.auction?.status === 'active' && startTime && !startTime.isAfter(now));
                                    
                                    if (!isLiveOrActive) return null;
                                    
                                    return (
                                        <button
                                            className="btn fw-bold text-white border-0 connect-to-bid-button live-bid-button"
                                            onClick={() => {
                                                const newWindow = window.open(
                                                    `/live-auctions/${auctionSlug}`,
                                                    '_blank',
                                                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1920,height=1080'
                                                );
                                                if (newWindow) {
                                                    newWindow.focus();
                                                }
                                            }}
                                            style={{
                                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                                padding: '12px 24px',
                                                fontSize: '13px',
                                                fontWeight: '700',
                                                letterSpacing: '0.5px',
                                                borderRadius: '10px',
                                                textTransform: 'uppercase',
                                                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                border: 'none',
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            CONNECT TO BID
                                        </button>
                                    );
                                })()}
                                
                                {/* Action Icons */}
                                <div className="d-flex gap-2">
                                    {/* Ellipsis Icon */}
                                    {/* <button
                                        className="btn p-0 border-0"
                                        style={{
                                            width: '44px',
                                            height: '44px',
                                            borderRadius: '10px',
                                            backgroundColor: '#ffffff',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#475569',
                                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                        }}
                                        onClick={() => {
                                            // TODO: Add menu functionality
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#f8fafc';
                                            e.currentTarget.style.borderColor = '#cbd5e1';
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.color = '#334155';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#ffffff';
                                            e.currentTarget.style.borderColor = '#e2e8f0';
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.color = '#475569';
                                        }}
                                        title="More options"
                                    >
                                        <FaEllipsisH style={{ fontSize: '16px' }} />
                                    </button> */}
                                    
                                    {/* Favorite Icon */}
                                    {onToggleFavorite && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onToggleFavorite}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: isFavorite ? '#fef2f2' : '#ffffff',
                                                border: `1px solid ${isFavorite ? '#fecaca' : '#e2e8f0'}`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: isFavorite ? '#ef4444' : '#475569',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = isFavorite ? '#fee2e2' : '#f8fafc';
                                                e.currentTarget.style.borderColor = isFavorite ? '#fca5a5' : '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = isFavorite ? '#fef2f2' : '#ffffff';
                                                e.currentTarget.style.borderColor = isFavorite ? '#fecaca' : '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                            }}
                                            title=""
                                        >
                                            {isFavorite ? (
                                                <FaHeart style={{ fontSize: '18px' }} />
                                            ) : (
                                                <FaRegHeart style={{ fontSize: '18px' }} />
                                            )}
                                        </button>
                                    )}
                                    
                                    {/* QR Code Icon */}
                                    {onQRCodeClick && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onQRCodeClick}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#1a1a1a',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                                e.currentTarget.style.borderColor = '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.color = '#000000';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.color = '#1a1a1a';
                                            }}
                                            title="Show QR Code"
                                        >
                                            <FaQrcode style={{ fontSize: '18px' }} />
                                        </button>
                                    )}
                                    
                                    {/* Share Icon */}
                                    {onShareClick && (
                                        <button
                                            className="btn p-0 border-0"
                                            onClick={onShareClick}
                                            style={{
                                                width: '44px',
                                                height: '44px',
                                                borderRadius: '10px',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #e2e8f0',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#475569',
                                                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#f8fafc';
                                                e.currentTarget.style.borderColor = '#cbd5e1';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.color = '#334155';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.color = '#475569';
                                            }}
                                            title="Share auction"
                                        >
                                            <FaShare style={{ fontSize: '18px' }} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Breadcrumb;

